
/* eslint-disable max-len */
import React from "react";
import { Link } from "react-router-dom";
import { Modal } from "seed/helpers"
import { ModalRoute } from "seed/helpers"
import l from "components/util/l";
import Board from "components/studio/board/Board";
import Toolbox from "components/studio/toolbox/Toolbox";
import RightNav from "components/studio/rightnav/RightNav";
import ActionForm from "components/studio/forms/action_form/ActionForm";
import ContactForm from "components/studio/forms/contact_us/ContactForm";
import ExecutionDetail from "components/studio/forms/execution/ExecutionDetail";
import ChatStudio from "components/presentation/chat/ChatStudio";
import NotificationsBell from "components/vmisc/notifications/NotificationsBell";
import WSManager from "components/util/ws";


const ControllerView = ({
  flow,
  pages,
  nodes,
  edges,
  user,
  selectedNodes,
  activePageId,
  reactFlowWrapper,
  currentExecutionId,
  wsExecutionRef,
  wsNodeRef,
  toolboxRef,
  toolboxActiveSection,
  rightNavActiveSection,
  showAnimations,
  isFlowBeingSaved,
  isGeneratingFlow,
  isOwner,
  isEditor,
  isValidator,
  isDeveloper,
  isAnonymous,
  isContactUsShown,
  isRPADesigner,
  isExecutionDetailsShown,
  isAnimationOptionShown,
  isToolboxCollapsed,
  isRightNavCollapsed,
  setIsContactUsShown,
  setReactFlowInstance,
  setIsExecutionDetailsShown,
  setToolboxActiveSection,
  createNode,
  onDropNode,
  onDragNode,
  onClickConnectEdge,
  onClickUpdateEdge,
  onNodesChange,
  onEdgesChange,
  onClickNode,
  onClickAnnotation,
  onClickUndo,
  onClickRedo,
  onClickChangePage,
  onClickDeleteSelectedNodes,
  onClickDeleteSelectedProcesses,
  onExecutionMessageReceived,
  onNodeMessageReceived,
  onClickChangeAnimations,
  onClickGenerateFlow,
  onClickOpenToolbox,
  onClickCloseToolbox,
  onClickCollapseToolbox,
  onClickCollapseRightNav,
  onClickVersions,
  onClickDuplicateSelectedNodes,
  reloadFlow,
}) => (
  <div id="flow" className={`${isValidator ? "validator" : ""}`}>
    <div class="container-fluid p-0 h-100">

      <div class="d-flex h-100">

        <div id="workspace" class={"w-100"}>
          {!isValidator && false && ( // TODO Force false
            <div id="workspace-header" className="d-flex justify-content-between align-items-center w-100">
              <div id="workspace-title" class="d-flex align-items-center">

                <a
                  className="back-button d-flex align-items-center justify-content-center"
                  title="Regresar"
                  href={`/app/${flow.token}`}
                  onClick={() => { }}>
                  <i class="fas fa-arrow-left d-block"></i>
                </a>

                <div class="w-auto ml-1">
                  <a className="d-flex" href={`/app/${flow.token}`} >
                    <div className="logo-workix"></div>
                    <div className="logo-sub"><label>Studio</label></div>
                  </a>
                </div>

              </div>

              <div id="workspace-actions" className="d-flex">

                <NotificationsBell
                  flow={flow}
                  isDebug={true}
                />
                {/* Temp hide 250807
                <span className="d-flex align-items-center">
                  <button className="btn btn-sm btn-outline-primary mr-2 py-2 share-button" onClick={onClickVersions}>
                    <i class="fas fa-clock-rotate-left"></i>
                  </button>
                </span>
                */}

                {!isAnonymous ?
                  <div id="workspace-pages">

                    <div id="page-dropdown" className="btn btn-sm btn-outline-primary py-2 px-3"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                      style={{fontSize: "0.95em"}}>

                      <span className="text-truncate text-center font-weight-bold" style={{ maxWidth: "11rem" }}>
                        {pages.find((page) => page.id == activePageId)?.name ?? "Página 1"}
                      </span>
                      <i class="fa-solid fa-caret-down ml-2"></i>
                    </div>


                    <div class="dropdown-menu">
                      {pages.map((page) => (
                        <a class="dropdown-item page-item d-flex justify-content-between align-items-center" key={page.id}
                          style={{ cursor: "pointer" }}
                          onClick={() => onClickChangePage(page.id)}>
                          <div class="py-1">{page.name}</div>
                          <Link class="py-1 btn-lighter page-edit-btn rounded"
                            to={`/flow/edit_page/${page.id}`}
                            style={{ paddingLeft: "0.7rem", paddingRight: "0.7rem" }}>
                            <i class="fa-solid fa-pen" style={{ fontSize: "0.9em", color: "#999", border: "none" }}></i></Link>
                        </a>
                      ))}
                      <div class="dropdown-divider"></div>
                      <Link class="dropdown-item" to={`/flow/create_page`}>
                        <i class="fa-solid fa-plus mr-2"></i>Crear página
                      </Link>

                    </div>
                  </div> : null}

                {isAnonymous && (
                  <button id="contact-us-btn" className="btn btn-sm btn-accent px-3 ml-2" onClick={() => setIsContactUsShown(true)}>
                    <i class="fa-solid fa-comment mr-1"></i> {l("Contáctanos%SA005")}
                  </button>
                )}

              </div>
            </div>
          )}

          <div id="workspace-content" className="d-flex flex-row" 
            style={{ paddingTop: isValidator || !isValidator ? "0rem" : "3.7rem"  }}>  {/* TODO Always true */}

            <div id="workspace-toolbox">
              {
                !isValidator &&
                  <Toolbox
                    toolboxRef={toolboxRef}
                    flow={flow}
                    pageId={activePageId}
                    nodes={nodes.filter((item) => item.type == "node")}
                    activeSection={toolboxActiveSection}
                    defaultWizardMode={true}
                    showTabs={false}
                    isAnonymous={isAnonymous}
                    isCollapsed={isToolboxCollapsed}
                    isValidator={isValidator}
                    setActiveSection={setToolboxActiveSection}
                    onClickNode={onClickNode}
                    onClickOpenToolbox={onClickOpenToolbox}
                    onClickCloseToolbox={onClickCloseToolbox}
                    reloadFlow={reloadFlow}
                  />
              }
            </div>


            <div id="workspace-board">

              {
                !isValidator &&
                  <div id="collapse-icon" onClick={onClickCollapseToolbox}>
                    {isToolboxCollapsed ?
                      <i class="fas fa-angle-right"></i>
                      : <i className="fas fa-angle-left"></i>
                    }
                  </div>
              }

              <Board
                nodes={nodes}
                edges={edges}
                user={user}
                flowId={flow.id}
                toolboxRef={toolboxRef}
                selectedNodes={selectedNodes}
                showAnimations={showAnimations}
                isFlowBeingSaved={isFlowBeingSaved}
                isGeneratingFlow={isGeneratingFlow}
                isRPADesigner={isRPADesigner}
                isDeveloper={isDeveloper}
                isAnonymous={isAnonymous}
                isAnimationOptionShown={isAnimationOptionShown}
                isValidator={isValidator}
                reactFlowWrapper={reactFlowWrapper}
                setReactFlowInstance={setReactFlowInstance}
                onDropNode={onDropNode}
                onDragNode={onDragNode}
                onClickConnectEdge={onClickConnectEdge}
                onClickUpdateEdge={onClickUpdateEdge}
                onNodesChange={onNodesChange}
                onEdgesChange={onEdgesChange}
                onClickNode={onClickNode}
                onClickAnnotation={onClickAnnotation}
                onClickDeleteSelectedNodes={onClickDeleteSelectedNodes}
                onClickDeleteSelectedProcesses={onClickDeleteSelectedProcesses}
                onClickUndo={onClickUndo}
                onClickRedo={onClickRedo}
                onClickChangeAnimations={onClickChangeAnimations}
                onClickGenerateFlow={onClickGenerateFlow}
                onClickDuplicateSelectedNodes={onClickDuplicateSelectedNodes}
              />
            </div>

            <RightNav
              flow={flow}
              activeSection={rightNavActiveSection}
              isCollapsed={isRightNavCollapsed}
              onClickCollapse={onClickCollapseRightNav}
            />
          </div>

        </div>

      </div>
    </div>

    {isContactUsShown && (
      <Modal
        width={500}
        height={500}
        animation={""}
        onClose={() => setIsContactUsShown(false)}
        component={ContactForm}
      />
    )}

    {isExecutionDetailsShown && (
      <Modal
        width={800}
        height={800}
        animation={""}
        executionId={currentExecutionId}
        isShown={true}
        isButtonHidden={true}
        onClose={() => setIsExecutionDetailsShown(false)}
        component={ExecutionDetail}
      />
    )}

    <ModalRoute
      width={1100}
      height={675}
      animation={""}
      path={"/action_form"}
      closeOnEsc={false}
      component={() =>
        <ActionForm
          flowId={flow.id}
          isValidator={isValidator}
          createNode={createNode}
          toolboxRef={toolboxRef}
          toolboxId={crypto.randomUUID()}
          pageId={activePageId}
          nodes={nodes.filter((item) => item.type == "node")}
          reloadFlow={reloadFlow}
        />
      }
    />

    <ModalRoute
      width={800}
      height={770}
      animation={""}
      path="/chat_studio"
      flowId={flow.id}
      component={ChatStudio}
    />

    <WSManager
      ref={wsExecutionRef}
      onMessageReceived={onExecutionMessageReceived}
    />

    <WSManager
      ref={wsNodeRef}
      onMessageReceived={onNodeMessageReceived}
    />

  </div>
);

export default ControllerView;